// Structure and Room Data
import Image1 from "../assets/img/image00001.webp";
import Image3 from "../assets/img/image00003.webp";

// Prione - Room 1
import Image1_1 from "../assets/img/prione_1_1.webp";
import Image1_2 from "../assets/img/prione_1_2.webp";
import Image1_3 from "../assets/img/prione_1_3.webp";
import Image1_4 from "../assets/img/prione_1_4.webp";

// Prione - Room 2
import Image2_1 from "../assets/img/prione_2_1.webp";
import Image2_2 from "../assets/img/prione_2_2.webp";
import Image2_3 from "../assets/img/prione_2_3.webp";
import Image2_4 from "../assets/img/prione_2_4.webp";
import Image2_5 from "../assets/img/prione_2_5.webp";

// Prione - Room 3
import Image3_1 from "../assets/img/prione_3_1.webp";
import Image3_2 from "../assets/img/prione_3_2.webp";
import Image3_3 from "../assets/img/prione_3_3.webp";
import Image3_4 from "../assets/img/prione_3_4.webp";
import Image3_5 from "../assets/img/prione_3_5.webp";

// Prione - Room 4
import Image4_1 from "../assets/img/prione_4_1.webp";
import Image4_2 from "../assets/img/prione_4_2.webp";
import Image4_3 from "../assets/img/prione_4_3.webp";
import Image4_4 from "../assets/img/prione_4_4.webp";
import Image4_5 from "../assets/img/prione_4_5.webp";

// Cavour - Room Glamour (Appartment)
import Cavour1_1 from "../assets/img/cavour_1_1.webp";
import Cavour1_2 from "../assets/img/cavour_1_2.webp";
import Cavour1_3 from "../assets/img/cavour_1_3.webp";
import Cavour1_4 from "../assets/img/cavour_1_4.webp";
import Cavour1_5 from "../assets/img/cavour_1_5.webp";
import Cavour1_6 from "../assets/img/cavour_1_6.webp";
import Cavour1_7 from "../assets/img/cavour_1_7.webp";
import Cavour1_8 from "../assets/img/cavour_1_8.webp";

// Cavour - Room Tiffany (Suite)
import Cavour2_1 from "../assets/img/cavour_2_1.webp";
import Cavour2_2 from "../assets/img/cavour_2_2.webp";
import Cavour2_3 from "../assets/img/cavour_2_3.webp";
import Cavour2_4 from "../assets/img/cavour_2_4.webp";
import Cavour2_5 from "../assets/img/cavour_2_5.webp";
import Cavour2_6 from "../assets/img/cavour_2_6.webp";
import Cavour2_7 from "../assets/img/cavour_2_7.webp";
import Cavour2_8 from "../assets/img/cavour_2_8.webp";

// Cavour - Room Cassia (Suite)
import Cavour3_1 from "../assets/img/cavour_3_1.webp";
import Cavour3_2 from "../assets/img/cavour_3_2.webp";
import Cavour3_3 from "../assets/img/cavour_3_3.webp";
import Cavour3_4 from "../assets/img/cavour_3_4.webp";
import Cavour3_5 from "../assets/img/cavour_3_5.webp";
import Cavour3_6 from "../assets/img/cavour_3_6.webp";
import Cavour3_7 from "../assets/img/cavour_3_7.webp";
import Cavour3_8 from "../assets/img/cavour_3_8.webp";

// Cavour - Room White
import Cavour4_1 from "../assets/img/cavour_4_1.webp";
import Cavour4_2 from "../assets/img/cavour_4_2.webp";
import Cavour4_3 from "../assets/img/cavour_4_3.webp";
import Cavour4_4 from "../assets/img/cavour_4_4.webp";
import Cavour4_5 from "../assets/img/cavour_4_5.webp";
import Cavour4_6 from "../assets/img/cavour_4_6.webp";
import Cavour4_7 from "../assets/img/cavour_4_7.webp";
import Cavour4_8 from "../assets/img/cavour_4_8.webp";

// Cavour - Room Rose
import Cavour5_1 from "../assets/img/cavour_5_1.webp";
import Cavour5_2 from "../assets/img/cavour_5_2.webp";
import Cavour5_3 from "../assets/img/cavour_5_3.webp";
import Cavour5_4 from "../assets/img/cavour_5_4.webp";
import Cavour5_5 from "../assets/img/cavour_5_5.webp";
import Cavour5_6 from "../assets/img/cavour_5_6.webp";
import Cavour5_7 from "../assets/img/cavour_5_7.webp";
import Cavour5_8 from "../assets/img/cavour_5_8.webp";

// Cavour - Room Green
import Cavour6_1 from "../assets/img/cavour_6_1.webp";
import Cavour6_2 from "../assets/img/cavour_6_2.webp";
import Cavour6_3 from "../assets/img/cavour_6_3.webp";
import Cavour6_4 from "../assets/img/cavour_6_4.webp";
import Cavour6_5 from "../assets/img/cavour_6_5.webp";
import Cavour6_6 from "../assets/img/cavour_6_6.webp";
import Cavour6_7 from "../assets/img/cavour_6_7.webp";
import Cavour6_8 from "../assets/img/cavour_6_8.webp";

// Cavour - Room Grey
import Cavour7_1 from "../assets/img/cavour_7_1.webp";
import Cavour7_2 from "../assets/img/cavour_7_2.webp";
import Cavour7_3 from "../assets/img/cavour_7_3.webp";
import Cavour7_4 from "../assets/img/cavour_7_4.webp";
import Cavour7_5 from "../assets/img/cavour_7_5.webp";
import Cavour7_6 from "../assets/img/cavour_7_6.webp";
import Cavour7_7 from "../assets/img/cavour_7_7.webp";
import Cavour7_8 from "../assets/img/cavour_7_8.webp";

// Cavour - Room Blue
import Cavour8_1 from "../assets/img/cavour_8_1.webp";
import Cavour8_2 from "../assets/img/cavour_8_2.webp";
import Cavour8_3 from "../assets/img/cavour_8_3.webp";
import Cavour8_4 from "../assets/img/cavour_8_4.webp";
import Cavour8_5 from "../assets/img/cavour_8_5.webp";
import Cavour8_6 from "../assets/img/cavour_8_6.webp";
import Cavour8_7 from "../assets/img/cavour_8_7.webp";
import Cavour8_8 from "../assets/img/cavour_8_8.webp";

export const structures = [
  {
    id: "cavour",
    name: "Cavour",
    fullName: "New Moon Cavour",
    address: "Corso Cavour, 160",
    city: "La Spezia",
    heroImage: Image1,
    cardImage: Cavour1_1,
    bookingUrl: "/camere",
    aboutSubtitle: "NEW MOON CAVOUR",
    aboutTitleKey: "structureData.cavour.aboutTitle",
    aboutDescriptionKeys: [
      "structureData.cavour.aboutDesc1",
      "structureData.cavour.aboutDesc2",
    ],
    amenities: [
      { nameKey: "amenities.freeWifi", icon: "FaWifi" },
      { nameKey: "amenities.smartTv", icon: "FaTv" },
      { nameKey: "amenities.airConditioning", icon: "FaSnowflake" },
      { nameKey: "amenities.kitchenette", icon: "MdKitchen" },
      { nameKey: "amenities.coffeeMachine", icon: "FaCoffee" },
      { nameKey: "amenities.elevator", icon: "MdElevator" },
      { nameKey: "amenities.privateJacuzzi", icon: "FaBath" },
    ],
    rooms: [
      {
        id: "glamour",
        nameKey: "structureData.cavour.glamour.name",
        descriptionKey: "structureData.cavour.glamour.description",
        fullDescriptionKeys: [],
        heroImage: Cavour1_1,
        images: [
          Cavour1_1,
          Cavour1_2,
          Cavour1_3,
          Cavour1_4,
          Cavour1_5,
          Cavour1_6,
          Cavour1_7,
          Cavour1_8,
        ],
        badge: "Jacuzzi",
        guests: 4,
        beds: 2,
        bathrooms: 1,
        size: "50 m²",
      },
      {
        id: "tiffany",
        nameKey: "structureData.cavour.tiffany.name",
        descriptionKey: "structureData.cavour.tiffany.description",
        fullDescriptionKeys: [],
        heroImage: Cavour2_1,
        images: [
          Cavour2_1,
          Cavour2_2,
          Cavour2_3,
          Cavour2_4,
          Cavour2_5,
          Cavour2_6,
          Cavour2_7,
          Cavour2_8,
        ],
        guests: 4,
        beds: 2,
        bathrooms: 1,
        size: "40 m²",
      },
      {
        id: "cassia",
        nameKey: "structureData.cavour.cassia.name",
        descriptionKey: "structureData.cavour.cassia.description",
        fullDescriptionKeys: [],
        heroImage: Cavour3_1,
        images: [
          Cavour3_1,
          Cavour3_2,
          Cavour3_3,
          Cavour3_4,
          Cavour3_5,
          Cavour3_6,
          Cavour3_7,
          Cavour3_8,
        ],
        guests: 4,
        beds: 2,
        bathrooms: 1,
        size: "30 m²",
      },
      {
        id: "white",
        nameKey: "structureData.cavour.white.name",
        descriptionKey: "structureData.cavour.white.description",
        fullDescriptionKeys: [],
        heroImage: Cavour4_1,
        images: [
          Cavour4_1,
          Cavour4_2,
          Cavour4_3,
          Cavour4_4,
          Cavour4_5,
          Cavour4_6,
          Cavour4_7,
          Cavour4_8,
        ],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "25 m²",
      },
      {
        id: "rose",
        nameKey: "structureData.cavour.rose.name",
        descriptionKey: "structureData.cavour.rose.description",
        fullDescriptionKeys: [],
        heroImage: Cavour5_1,
        images: [
          Cavour5_1,
          Cavour5_2,
          Cavour5_3,
          Cavour5_4,
          Cavour5_5,
          Cavour5_6,
          Cavour5_7,
          Cavour5_8,
        ],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "25 m²",
      },
      {
        id: "green",
        nameKey: "structureData.cavour.green.name",
        descriptionKey: "structureData.cavour.green.description",
        fullDescriptionKeys: [],
        heroImage: Cavour6_1,
        images: [
          Cavour6_1,
          Cavour6_2,
          Cavour6_3,
          Cavour6_4,
          Cavour6_5,
          Cavour6_6,
          Cavour6_7,
          Cavour6_8,
        ],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "27 m²",
      },
      {
        id: "grey",
        nameKey: "structureData.cavour.grey.name",
        descriptionKey: "structureData.cavour.grey.description",
        fullDescriptionKeys: [],
        heroImage: Cavour7_1,
        images: [
          Cavour7_1,
          Cavour7_2,
          Cavour7_3,
          Cavour7_4,
          Cavour7_5,
          Cavour7_6,
          Cavour7_7,
          Cavour7_8,
        ],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "28 m²",
      },
      {
        id: "blue",
        nameKey: "structureData.cavour.blue.name",
        descriptionKey: "structureData.cavour.blue.description",
        fullDescriptionKeys: [],
        heroImage: Cavour8_1,
        images: [
          Cavour8_1,
          Cavour8_2,
          Cavour8_3,
          Cavour8_4,
          Cavour8_5,
          Cavour8_6,
          Cavour8_7,
          Cavour8_8,
        ],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "26 m²",
      },
    ],
  },
  {
    id: "prione",
    name: "Prione",
    fullName: "New Moon Prione",
    address: "Via del Prione, 165",
    city: "La Spezia",
    heroImage: Image3,
    cardImage: Image2_1,
    bookingUrl: "/camere",
    aboutTitleKey: "structureData.pirone.aboutTitle",
    aboutDescriptionKeys: [
      "structureData.pirone.aboutDesc1",
      "structureData.pirone.aboutDesc2",
    ],
    amenities: [
      { nameKey: "amenities.freeWifi", icon: "FaWifi" },
      { nameKey: "amenities.smartTv", icon: "FaTv" },
      { nameKey: "amenities.airConditioning", icon: "FaSnowflake" },
      { nameKey: "amenities.kitchenette", icon: "MdKitchen" },
      { nameKey: "amenities.coffeeMachine", icon: "FaCoffee" },
    ],
    rooms: [
      {
        id: "one",
        nameKey: "structureData.pirone.one.name",
        descriptionKey: "structureData.pirone.one.description",
        fullDescriptionKeys: [
          "structureData.pirone.one.fullDesc1",
          "structureData.pirone.one.fullDesc2",
        ],
        heroImage: Image1_1,
        images: [Image1_1, Image1_2, Image1_3, Image1_4],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "28 m²",
      },
      {
        id: "two",
        nameKey: "structureData.pirone.two.name",
        descriptionKey: "structureData.pirone.two.description",
        fullDescriptionKeys: [
          "structureData.pirone.two.fullDesc1",
          "structureData.pirone.two.fullDesc2",
        ],
        heroImage: Image2_1,
        images: [Image2_1, Image2_2, Image2_3, Image2_4, Image2_5],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "45 m²",
      },
      {
        id: "three",
        nameKey: "structureData.pirone.three.name",
        descriptionKey: "structureData.pirone.three.description",
        fullDescriptionKeys: [
          "structureData.pirone.three.fullDesc1",
          "structureData.pirone.three.fullDesc2",
        ],
        heroImage: Image3_1,
        images: [Image3_1, Image3_2, Image3_3, Image3_4, Image3_5],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "40 m²",
      },
      {
        id: "four",
        nameKey: "structureData.pirone.four.name",
        descriptionKey: "structureData.pirone.four.description",
        fullDescriptionKeys: [
          "structureData.pirone.four.fullDesc1",
          "structureData.pirone.four.fullDesc2",
        ],
        heroImage: Image4_1,
        images: [Image4_1, Image4_2, Image4_3, Image4_4, Image4_5],
        guests: 2,
        beds: 1,
        bathrooms: 1,
        size: "30 m²",
      },
    ],
  },
];

// Amenity keys for translation
export const amenities = [
  { nameKey: "amenities.freeWifi", icon: "FaWifi" },
  { nameKey: "amenities.smartTv", icon: "FaTv" },
  { nameKey: "amenities.airConditioning", icon: "FaSnowflake" },
  { nameKey: "amenities.kitchenette", icon: "MdKitchen" },
  { nameKey: "amenities.coffeeMachine", icon: "FaCoffee" },
  { nameKey: "amenities.elevator", icon: "MdElevator" },
  { nameKey: "amenities.freeParkingNearby", icon: "FaParking" },
];

// Helper function to get structure by ID
export const getStructureById = (id) => {
  return structures.find((s) => s.id === id);
};

// Helper function to get room by structure ID and room ID
export const getRoomByIds = (structureId, roomId) => {
  const structure = getStructureById(structureId);
  if (!structure) return null;
  const room = structure.rooms.find((r) => r.id === roomId);
  if (!room) return null;
  return { structure, room };
};
